import { Component, OnInit } from "@angular/core";
import { PRODUCT_NAME } from "src/app/core";
import { AssistantService } from "../../../services/assistant.service";

@Component({
    selector: "app-assistant-popup-header",
    templateUrl: "./assistant-popup-header.component.html",
    styleUrls: ["./assistant-popup-header.component.scss"],
    standalone: false
})
export class AssistantPopupHeaderComponent implements OnInit {
  readonly PRODUCT_NAME = PRODUCT_NAME;
  constructor(private assistantService: AssistantService) {}

  ngOnInit(): void {}

  onHelp(): void {
    this.assistantService.showSupportAgent();
  }

  onMinimize(): void {
    this.assistantService.close(true);
  }
}
